import { render } from "./SideNavi.vue?vue&type=template&id=fdb32308&scoped=true"
import script from "./SideNavi.vue?vue&type=script&lang=js"
export * from "./SideNavi.vue?vue&type=script&lang=js"

import "./SideNavi.vue?vue&type=style&index=0&id=fdb32308&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb32308"]])

export default __exports__